$.ajax({
    url: '/cart.json',
    type: 'get',
    dataType: 'json',
    success: function(response) {
        cartJson = response;
        var ioId = {};
        $.each(cartJson.items, function(key, value) {
            if (value.properties !== null && value.properties._io_parent_order_group !== undefined) {
                idVal = value.properties._io_parent_order_group;
                if (ioId[idVal]) {
                    ioId[idVal].push({
                        'child': value.key,
                        'quantity': value.quantity
                    });
                } else {
                    ioId[idVal] = [{
                        'child': value.key,
                        'quantity': value.quantity
                    }];
                }
            }
            if (value.properties !== null && value.properties._io_order_group !== undefined) {
                idVal = value.properties._io_order_group;
                if (ioId[idVal]) {
                    ioId[idVal].push({
                        'parent': value.key,
                        'quantity': value.quantity
                    });
                } else {
                    ioId[idVal] = [{
                        'parent': value.key,
                        'quantity': value.quantity
                    }];
                }
            }
        });
        $.each(ioId, function(i, e) {
            if (e.length != 2) {
                $.each(e, function(key, arr) {
                    cartQty = arr.quantity;
                    if (arr.parent !== undefined) {
                        $.ajax({
                            url: '/cart/change.js',
                            type: 'post',
                            dataType: 'json',
                            data: {
                                'id': arr.parent,
                                'quantity': cartQty,
                                'properties': {
                                    '_removed': ''
                                }
                            },
                            success: function(cart) {
                                location.reload();
                            }
                        })
                    }
                    if (arr.child !== undefined) {
                        $.ajax({
                            url: '/cart/update.js',
                            type: 'post',
                            dataType: 'json',
                            data: {
                                updates: {
                                    [arr.child]: 0
                                }
                            },
                            success: function(cart) {
                                location.reload();
                            }
                        })
                    }
                });
            }
            if (e.length == 2) {
                $.each(e, function(key, arr) {
                    if (arr.parent !== undefined) {
                        parQty = arr.quantity
                    }
                    if (arr.child !== undefined) {
                        chQty = arr.quantity
                        if (chQty != parQty) {
                            $.ajax({
                                url: '/cart/update.js',
                                type: 'post',
                                dataType: 'json',
                                data: {
                                    updates: {
                                        [arr.child]: parQty
                                    }
                                },
                                success: function(cart) {
                                    location.reload();
                                }
                            })
                        }
                    }
                });
            }
        });
    }
})